import { isEmpty, isNil } from 'lodash';
import { fieldFromComponentData } from '@shared/data/entity/fields/fieldFromComponentData';
import { API } from '@shared/types/api';

export function countCompletedSubformFields(
  components: API.AnyComponent[],
  data: Record<string, any>,
): number {
  if (isEmpty(components) || isNil(data)) {
    return 0;
  }
  let count = 0;
  for (const component of components) {
    const raw = data[component.id];
    if (isNil(raw)) {
      continue;
    }
    const field = fieldFromComponentData(component, raw);
    if (!isNil(field) && !field.isEmpty) {
      count += 1;
    }
  }
  return count;
}
